import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/erp/ui";
import { ShieldCheck } from "lucide-react";

const when = (s) => new Date(s).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

// Riwayat siapa yang approve pemilihan filament manual (PIN owner / PIC manager)
export const ApprovalHistory = () => {
  const [rows, setRows] = useState(null); const [n, setN] = useState(10);
  useEffect(() => { api.get("/prod/spool-approvals").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);
  if (!rows) return null;
  return (
    <Card className="p-4" data-testid="approval-history">
      <div className="flex items-center gap-2 font-semibold text-sm mb-2"><ShieldCheck className="w-4 h-4 text-emerald-600" /> Riwayat approval pilih filament manual <span className="text-slate-400 font-normal">({rows.length})</span></div>
      <div className="overflow-x-auto"><table className="w-full text-xs">
        <thead className="text-slate-500 bg-slate-50"><tr><th className="p-2 text-left">Waktu</th><th className="p-2 text-left">Disetujui oleh</th><th className="p-2 text-left">Diminta oleh</th><th className="p-2 text-left">WO · file</th><th className="p-2 text-left">Spool</th></tr></thead>
        <tbody>
          {rows.slice(0, n).map((a) => (
            <tr key={a.id} className="border-t border-slate-100" data-testid={`approval-row-${a.id}`}>
              <td className="p-2 whitespace-nowrap">{when(a.at)}</td><td className="p-2 font-semibold">{a.approver}<div className="text-[10px] text-slate-400 font-normal">{a.approver_email}</div></td>
              <td className="p-2">{a.requested_by}</td><td className="p-2">{a.wo_code} · {a.file_name}</td>
              <td className="p-2"><span className="font-mono">{a.spool_code}</span> · {a.material} {a.color}{a.from_stock ? <span className="text-amber-700"> · dari stok</span> : ""}</td>
            </tr>
          ))}
          {!rows.length && <tr><td colSpan={5} className="p-3 text-center text-slate-400">Belum ada approval</td></tr>}
        </tbody>
      </table></div>
      {rows.length > n && <button type="button" className="text-xs text-sky-700 mt-2" data-testid="approval-more" onClick={() => setN(n + 20)}>Tampilkan lebih banyak</button>}
    </Card>
  );
};
